import { Card, CardContent, CardHeader, Divider, IconButton, makeStyles, Grid } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import { AaAboutContent } from './AboutContent';
import { DeleteComponent } from '../DeleteRepoAndCatalogButton';

import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { useEntity } from '@backstage/plugin-catalog-react';
import { ManageArgoButton } from '../ManageArgoAppButton/ManageArgoButton';
import { AdminToggled, unifiedGithubApiRef } from '@runway/devkit';
import { useState } from 'react';

const useStyles = makeStyles({
  gridItemCard: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 10px)', // for pages without content header
    marginBottom: '10px',
  },
  gridItemCardContent: {
    flex: 1,
  },
  cardHeader: {
    marginBottom: '20px',
  },
});

type AboutCardProps = {
  variant?: string;
};

export function AaAboutCard({ variant }: AboutCardProps) {
  const unifiedGithubApi = useApi(unifiedGithubApiRef);
  const { entity } = useEntity();

  const classes = useStyles();
  const [isGithubRepoAdmin, setIsGithubRepoAdmin] = useState(false);
  const projectSlug = unifiedGithubApi.getProjectSlugForEntity({ entity });

  useAsync(async () => {
    if (!projectSlug) {
      setIsGithubRepoAdmin(false);
      return;
    }

    const username = await unifiedGithubApi.getCurrentUsernameForEntity({ entity });
    const permissionLevel = await unifiedGithubApi.getCollaboratorPermissionLevelForEntity({ entity, username });
    setIsGithubRepoAdmin(permissionLevel === 'admin');
  }, [entity, projectSlug, unifiedGithubApi]);

  async function aaYamlUrlCreatorAndOpener() {
    if (!projectSlug) {
      return;
    }

    const [owner, repo] = projectSlug.split('/');
    const repoUrl = `https://github.com/${owner}/${repo}`;

    try {
      const [defaultBranch, aaYamlExists] = await Promise.all([
        unifiedGithubApi.getDefaultBranchForEntity({ entity }),
        unifiedGithubApi.checkFileExistsForEntity({ entity, filePath: 'aa.yaml' }),
      ]);

      const concatUrl = aaYamlExists
        ? `${repoUrl}/edit/${defaultBranch}/aa.yaml`
        : `${repoUrl}/new/${defaultBranch}/?filename=aa.yaml`;

      window.open(concatUrl, '_blank', 'noopener,noreferrer');
    } catch (error: any) {
      const response = {
        message: error.message || 'Ooops. Something is broken.',
        details: error.response?.data || 'No further details available',
      };
      // eslint-disable-next-line no-console
      console.error(response);
    }
  }

  return (
    <Card className={variant === 'gridItem' ? classes.gridItemCard : ''}>
      <CardHeader
        title="Runway Information"
        className={classes.cardHeader}
        action={
          <IconButton
            aria-label="Edit"
            disabled={!projectSlug}
            title="Edit AA Yaml"
            onClick={() => {
              aaYamlUrlCreatorAndOpener();
            }}
          >
            <EditIcon />
          </IconButton>
        }
      />
      <Divider />
      <CardContent className={variant === 'gridItem' ? classes.gridItemCardContent : ''}>
        <AaAboutContent entity={entity} />
        <AdminToggled toggleName="maintenance-mode">
          <Grid container>
            <Grid item>
              <ManageArgoButton entity={entity} isGithubRepoAdmin={isGithubRepoAdmin} />
            </Grid>
            <AdminToggled.HideOnEnabled>
              <Grid item>
                <DeleteComponent entity={entity} isGithubRepoAdmin={isGithubRepoAdmin} />
              </Grid>
            </AdminToggled.HideOnEnabled>
          </Grid>
        </AdminToggled>
      </CardContent>
    </Card>
  );
}
